import React, { lazy, Suspense, useMemo } from 'react';
import type { LocationSummary as Location } from '@/lib/locations';

const BORTLE_COLORS: Record<number, string> = {
  1: '#000000',
  2: '#333333',
  3: '#0000CC',
  4: '#007099',
  5: '#00CC00',
  6: '#99CC00',
  7: '#FFFF00',
  8: '#FF8800',
  9: '#FF0000',
};

interface Props {
  locations: Location[];
  onMarkerClick?: (slug: string) => void;
}

// Lazy-load the map internals to avoid SSR crashes
const MapInner = lazy(() => import('./LocationsMapInner'));

export const LocationsMap: React.FC<Props> = ({ locations, onMarkerClick }) => {
  return (
    <Suspense
      fallback={
        <div className="w-full h-[400px] bg-[#0f1923] rounded-[4px] flex items-center justify-center">
          <span className="text-white/40 text-sm">Loading map...</span>
        </div>
      }
    >
      <MapInner locations={locations} onMarkerClick={onMarkerClick} />
    </Suspense>
  );
};

export { BORTLE_COLORS };
